import React from 'react';
import './styles.css';
import { Doughnut } from 'react-chartjs-2'
import i18n from '../../../translate/i18n';

interface TypeProps {
  title: string,
  processosTempoMedio: number,
  completaTempoMedio: number,
  remotaTempoMedio: number,
  periciaTempoMedio: number,
}

export default function WidgetChartDoughnut({ title, processosTempoMedio, completaTempoMedio, remotaTempoMedio, periciaTempoMedio, }: TypeProps) {


  const data = {
    labels: [i18n.t<string>('full'), i18n.t<string>('remote'), i18n.t<string>('expertise')],
    datasets: [
      {
        data: [completaTempoMedio, remotaTempoMedio, periciaTempoMedio],
        backgroundColor: [
          "#3DD598",
          "#0062FF",
          "#FFC542"
        ],
        borderColor: [
          "#3DD598",
          "#0062FF",
          "#FFC542"
        ],
        borderWidth: 1,
      },
    ],
  };
  var options: any = {
    cutout: 85
  };

  return (
    <div id='container-widget-chart-doughnut'>
      <h1>{title}</h1>
      <div id='widget-chart-doughnut'>
        <span className='text-center-doughnut'>
          <h3>{processosTempoMedio} {i18n.t<string>('days')}</h3>
          <p>{title}</p>
        </span>
        <Doughnut data={data} options={options} />
        <ul>
          <li><div className='circle-completa'></div>{i18n.t<string>('full')} <strong>{completaTempoMedio} {i18n.t<string>('days')}</strong></li>
          <li><div className='circle-Remota'></div>{i18n.t<string>('remote')} <strong>{remotaTempoMedio} {i18n.t<string>('days')}</strong></li>
          <li><div className='circle-Perícia'></div>{i18n.t<string>('expertise')} <strong>{periciaTempoMedio} {i18n.t<string>('days')}</strong></li>
        </ul>
      </div>
    </div>
  )
}
